import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../../../firebase/AuthProvider";
import { changePassword } from "../../../../services/userServices/TeamService";
import Loader from "../../loader/Loader";
import { Button } from "react-bootstrap";
import openeyeicon from "../../../../assets/images/openeyeicon.svg";
import eyecloseicon from "../../../../assets/images/eyecloseicon.svg";

const ChangePassword: React.FC = () => {
    const [searchParams] = useSearchParams();
    const view = searchParams.get("view") || "general";
    const { currentUser } = useAuth();
    const token = (currentUser as any)?.accessToken;

    const [formData, setFormData] = useState({
        // currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validateForm = () => {
        const newErrors: { [key: string]: string } = {};

        if (!formData.newPassword) newErrors.newPassword = "New password is required.";
        if (!formData.confirmPassword) newErrors.confirmPassword = "Confirm your new password.";

        // Strong password check (adjust regex as needed)
        const strongPasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        if (formData.newPassword && !strongPasswordRegex.test(formData.newPassword)) {
            newErrors.newPassword =
                "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.";
        }

        if (formData.newPassword !== formData.confirmPassword) {
            newErrors.confirmPassword = "New passwords do not match.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!token) {
            toast.error("User not authenticated.");
            return;
        }

        if (!validateForm()) return;
        setLoading(true);
        try {
            const result = await changePassword(formData.newPassword, token);
            console.log(result, "result");

            if (result) {
                toast.success("Password updated successfully!");
                setFormData({ newPassword: "", confirmPassword: "" });
                setErrors({});
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Failed to update password. Please try again.");
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong.");
            setLoading(false);
        }
    };

    return (
        <>
            {loading ? <Loader /> : null}
            <div className="row">
                <div className="col-md-8 mx-auto">
                    <div className="common_card">
                        {view === "general" && (
                            <>
                                <div className="top border_tittle">
                                    <div className="top_bar_tittle">
                                        <h2>Change Password</h2>
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    {/* <div>
                                        <label className="block mb-1 text-sm text-gray-600">Current Password</label>
                                        <input
                                            type="password"
                                            name="currentPassword"
                                            value={formData.currentPassword}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:border-blue-300"
                                        />
                                        {errors.currentPassword && (
                                            <p className="text-red-500 text-sm">{errors.currentPassword}</p>
                                        )}
                                    </div> */}

                                    <div className="custom_input_flled">
                                        <label>New Password</label>
                                        <div className="filled_input_icon">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="newPassword"
                                                value={formData.newPassword}
                                                onChange={handleChange}
                                                placeholder="Enter new password"
                                            />
                                            {/* <div
                                                // type="button"
                                                onClick={() => setShowPassword((prev) => !prev)}
                                                className="icon_img"
                                            >
                                                {showPassword ? "🙈" : "👁️"}
                                            </div> */}
                                            <button onClick={() => setShowPassword((prev) => !prev)} className="icon_img">
                                                {showPassword ? (
                                                    <img src={openeyeicon} alt="eyeopenicon" />
                                                ) : (
                                                    <img src={eyecloseicon} alt="eyecloseicon" />
                                                )}
                                            </button>
                                        </div>
                                        {errors.newPassword && (
                                            <p className="text-red-500 text-sm">{errors.newPassword}</p>
                                        )}
                                    </div>

                                    <div className="custom_input_flled mb-0">
                                        <label>Confirm New Password</label>
                                        <div className="filled_input_icon">
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                name="confirmPassword"
                                                value={formData.confirmPassword}
                                                onChange={handleChange}
                                                placeholder="Enter confirm new password"
                                            />
                                            {/* <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                                            className=" right-3 top-9 text-xl text-gray-500 focus:outline-none"
                                        >
                                            {showConfirmPassword ? "🙈" : "👁️"}
                                        </button> */}
                                            <button onClick={() => setShowConfirmPassword((prev) => !prev)} className="icon_img">
                                                {showConfirmPassword ? (
                                                    <img src={openeyeicon} alt="eyeopenicon" />
                                                ) : (
                                                    <img src={eyecloseicon} alt="eyecloseicon" />
                                                )}
                                            </button>
                                        </div>
                                        {errors.confirmPassword && (
                                            <p className="text-red-500 text-sm">{errors.confirmPassword}</p>
                                        )}
                                    </div>
                                    <div className="form_btn_flx mby_t_24">
                                        <Button variant="primary" type="submit">Change Password</Button>
                                    </div>
                                </form>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangePassword;